import LeftRegister from './LeftRegister'

export default LeftRegister
